import React from 'react';

/**
 * Renders a vertical depth ladder for one side of the orderbook.
 * Each level shows price + quantity, with a coloured bar sized
 * relative to the largest quantity in the visible levels.
 */
const OrderbookDepth = ({ side, data }) => {
  const maxQty = Math.max(...(data || []).map((d) => d.quantity), 1);
  const isBid = side === 'bids';

  return (
    <div className="space-y-1">
      {(data || []).slice(0, 5).map((level, idx) => (
        <div key={idx} className="relative flex items-center text-xs h-6">
          <div
            className={`absolute inset-y-0 ${isBid ? 'right-0 bg-green-500/20' : 'left-0 bg-red-500/20'}`}
            style={{ width: `${(level.quantity / maxQty) * 100}%` }}
          />
          <div className="relative flex w-full justify-between px-2">
            <span className={isBid ? 'text-green-400' : 'text-red-400'}>{level.price}¢</span>
            <span className="text-gray-400">{level.quantity}</span>
          </div>
        </div>
      ))}
      {(!data || data.length === 0) && (
        <div className="text-xs text-gray-500 text-center py-2">No orders</div>
      )}
    </div>
  );
};

export default OrderbookDepth;
